import React from "react"
import {ChevronLeft} from "react-bootstrap-icons";
import {useNavigate} from "react-router-dom";

const BackToStart = () => {
    const navigate = useNavigate()
    return (
        <div className="float-end pointer" onClick={() => {navigate('/search')}}>
            <ChevronLeft />
            <span>Tillbaka</span>
        </div>
    )
}

export default BackToStart